// Shared so App.js can route on it without pulling the NewsCategory page chunk
// into the main bundle.
export const NEWS_CATEGORIES = {
  "premier-league": "Premier League",
  "la-liga": "La Liga",
  "serie-a": "Serie A",
  "bundesliga": "Bundesliga",
  "ligue-1": "Ligue 1",
  "champions-league": "Champions League",
  "mls": "MLS",
  "saudi-pro-league": "Saudi Pro League",
};
